import type { tickets } from '@repletoryreach/sdk-api';

const CATEGORY_ORDER: Record<string, number> = { new: 0, open: 1, pending: 2, on_hold: 3, solved: 4, closed: 5 };

/** By category in the order a ticket moves through them, then by the business's own order. */
export function byStatusOrder(a: tickets.Status, b: tickets.Status): number {
  return (CATEGORY_ORDER[a.category] ?? 9) - (CATEGORY_ORDER[b.category] ?? 9) || a.sort_order - b.sort_order || a.name.localeCompare(b.name);
}

/** The statuses a ticket of this type may take: those for every type plus the type's own. */
export function statusesForType(statuses: readonly tickets.Status[], typeId: string | null | undefined): tickets.Status[] {
  return statuses.filter((s) => s.type_id === null || s.type_id === typeId).sort(byStatusOrder);
}
